export default __webpack_public_path__ + "static/media/shape1.36c51eae.png";